import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Breadcrumb, Col, Dropdown } from "react-bootstrap";
import { FiHome, FiGrid, FiList, FiColumns, FiDownload } from "react-icons/fi";
import { RiHome6Line } from "react-icons/ri";
import { MdKeyboardArrowRight } from "react-icons/md";


const CandidatesHeader = () => {
  const location = useLocation();

  return (
    <div className="page-breadcrumb d-md-flex d-block align-items-center justify-content-between mb-3">

      {/* LEFT */}
 <Col md={4} sm={12}>
                  <div className="my-auto mb-2">
                    <h4 style={{ fontWeight: "600", marginBottom: "5px" }}>Candidates List</h4>
        
                    <Breadcrumb
                      style={{
                        background: "transparent",
                        padding: 0,
                        margin: 0,
                        fontSize: "14px",
                      }}
                    >
                      <Breadcrumb.Item>
                      <Link  to="/" >
               
                        <RiHome6Line
                          className="m text-dark"
                          style={{
                            fontSize: "1.2rem", // increased icon size
                            verticalAlign: "middle",
                                                     }}
                        /></Link>
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item
                        linkAs="span"
                        className="text-dark text-decoration-none fs-6"
                      >
                    Administration
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item active>
                        <span className="text-dark fs-6">Candidates </span>
                      </Breadcrumb.Item>
                    </Breadcrumb>
                  </div>
                </Col>

      {/* RIGHT */}
      <div className="d-flex align-items-center flex-wrap">

        {/* VIEW SWITCH */}
        <div className="me-2 mb-2">
          <div className="view-switch">

            <Link
              to="/candidates-kanban"
              className={`icon-btn ${location.pathname === "/candidates-kanban" ? "active" : ""}`}
            >
              <FiColumns />
            </Link>

            <Link
              to="/candidates-list"
              className={`icon-btn ${location.pathname === "/candidates-list" ? "active" : ""}`}
            >
              <FiList />
            </Link>

            <Link
              to="/candidates-grid"
              className={`icon-btn ${location.pathname === "/candidates-grid" ? "active" : ""}`}
            >
              <FiGrid />
            </Link>

          </div>
        </div>

        {/* EXPORT */}
        <Dropdown className="me-2 mb-2">
          <Dropdown.Toggle className="export-btn">
            <FiDownload className="me-1" /> Export
          </Dropdown.Toggle>

          <Dropdown.Menu align="end">
            <Dropdown.Item>Export as PDF</Dropdown.Item>
            <Dropdown.Item>Export as Excel</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>

      </div>
      <style>
          {
               `
               /* HEADER */
.page-breadcrumb h2 {
  font-weight: 600;
}

.breadcrumb {
  font-size: 14px;
}

/* VIEW SWITCH */
.view-switch {
  display: flex;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 3px;
  background: #fff;
}

.icon-btn {
  padding: 6px 10px;
  border-radius: 6px;
  color: #333;
}

.icon-btn.active {
  background: #ff6b1a;
  color: #fff;
}

/* EXPORT */
.export-btn {
  background: #fff !important;
  border: 1px solid #ddd !important;
  color: #333 !important;
}

/* GRID IMAGE */
.candidate-img {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  object-fit: cover;
}

/* RESPONSIVE */
@media (max-width: 768px) {
  .page-breadcrumb {
    flex-direction: column;
    align-items: flex-start;
  }
}`
          }
      </style>
    </div>
  );
};

export default CandidatesHeader;